import axios, {Axios, AxiosError} from "axios";
import { loadSessionId } from "../../util/sessions";

export interface Sale {
  date: Date;
  stage: number;
  sum: number;
  userId: string;
}

interface SalesResponse {
  result: Sale[];
}

export interface SaleByUserId {
  [key: string]: Sale | string;
}


class SalesController {
  private axiosInstance: Axios;
  private sessionId: string;

  constructor() {
      this.sessionId = loadSessionId()
    this.axiosInstance = axios.create({
      headers: {
        'Accept': 'application/json',
      }
    });
  }

  private async callApi<T>(method: string): Promise<T> {
    try {
      const response = await this.axiosInstance.request<T>({
        method: 'GET',
        url: `https://slaver.vip/api/zchat/${method}?id=${this.sessionId}`,
      });
      return response.data;
    } catch(e: AxiosError | any) {
      throw new Error(e.response?.data?.error || e.message);
    }
  }

  async sales(): Promise<Sale[]> {
    return (await this.callApi<SalesResponse>('z-sales')).result;
  }
}

function getSalesController() {
  return new SalesController();
}

export default getSalesController;
